module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("绑定分组课件修复")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "空则扫全部 stars>1 学生"
    },
    model: {
      value: (_vm.uid),
      callback: function($$v) {
        _vm.uid = $$v
      },
      expression: "uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "padding-top": "4px"
    },
    attrs: {
      "span": "12"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.scanLoading,
      "icon": "search"
    },
    on: {
      "click": function($event) {
        return _vm.scan(false)
      }
    }
  }, [_vm._v("检查")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "error",
      "loading": _vm.fixLoading,
      "disabled": !_vm.canFix
    },
    on: {
      "click": _vm.confirmFix
    }
  }, [_vm._v("一键修复")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "8px 0 12px"
    }
  }, [_vm._v("\n    只处理 stars>1 的多级别学生。检查只看不改；修复会改未来已选课件。\n    学生 " + _vm._s(_vm.result.studentCount || 0) + "，错课 " + _vm._s(_vm.result.wrongCount || 0) + "，已修 " + _vm._s(_vm.result.fixedCount || 0) + "，\n    近5分钟跳过 " + _vm._s(_vm.result.skippedNearCount || 0) + "，陪练组跳过 " + _vm._s(_vm.result.skippedPartnerGroups || 0) + "\n  ")]), _vm._v(" "), _c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.columns,
      "data": _vm.rows
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53a3b5b6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/BindGroupLessonScan.vue
// module id = 1798
// module chunks = 8